<ng-container *ngIf="elementLock !== undefined && elementLock.lockType === ElementLockType.LOCK_CARD && elementLock.cardObject.id === cardPatternId">
  <img matTooltip="{{this.elementLock.communityMember.username}}" class="avatar-icon-lock" src="{{this.getAvatarTemplateUrl(this.elementLock.communityMember.avatarTemplate)}}" alt="avatarImage">
</ng-container>
<mat-sidenav-container *ngIf="cardPattern$ | async as cardPattern; else loading">
  <mat-sidenav-content>
    <mat-card class="mat-card-class" [ngClass]="{'problemStyles':cardPattern.cardDeckType === 'problem', 'patternStyles':cardPattern.cardDeckType === 'pattern', 'lockStyles': elementLock !== undefined && elementLock.cardObject.id === cardPattern.id}">
      <div class="card_pattern_frontside">
        <table class="card_table">
          <tbody>
          <tr>
            <td rowspan="2" class="card_cell_cardnumber" emAddedGameElement [elementId]="cardPattern.id">
              <div class="disable-text-selection">{{ cardPattern.cardNumber }}</div>
            </td>
            <td class="card_cell"></td>
            <td class="card_cell_direction card_cell_direction_redux_up" role="button" style="cursor:default;"></td>
            <td class="card_cell"></td>
            <td class="card_cell">
              <img *ngIf="this.isFromDeckTypePattern() && !this.showSelectToggle" class="controlLoopImage"
                   src="../../../assets/files/{{this.controlLoopImageName}}" alt="" width="45" height="45" >

              <em-element-add *ngIf="this.showSelectToggle" [cardPattern]="cardPattern"></em-element-add>
            </td>
          </tr>
          <tr>
            <td rowspan="4" colspan="3" class="card_cell_pic">
              <img class="img_card"
                   [src]="cardPattern.imageUrl" alt="Icon"
                   emAddedGameElement [elementId]="cardPattern.id">
            </td>
            <td class="card_cell"></td>
          </tr>
          <tr>
            <td class="card_cell_direction card_cell_direction_redux_left disable-text-selection" style="cursor:default;"></td>
            <td class="card_cell_direction card_cell_direction_redux_right disable-text-selection" style="cursor:default;">&nbsp;</td>
          </tr>
          <tr>
            <td class="card_cell"></td>
            <td class="card_cell"></td>
          </tr>
          <tr>
            <td class="card_cell"></td>
            <td class="card_cell"></td>
          </tr>
          <tr>
            <td rowspan="2" colspan="5" class="card_cell_title disable-text-selection" emAddedGameElement [elementId]="cardPattern.id">
              {{ cardPattern.name }}
            </td>
          </tr>
          <tr>
            <td class="card_cell"></td>
            <td class="card_cell"></td>
            <td class="card_cell"></td>
            <td class="card_cell"></td>
            <td class="card_cell"></td>
          </tr>
          <tr>
            <td class="card_cell_number_left_without_border"></td>
            <td class="card_cell_number_middle_without_border"></td>
            <td class="card_cell_number_middle_without_border"></td>
            <td class="card_cell_number_middle_without_border"></td>
            <td class="card_cell_number_right_without_border"></td>
          </tr>
          <tr>
            <td class="card_cell_number_left_without_border"></td>
            <td class="card_cell_number_middle_without_border"></td>
            <td class="card_cell_number_middle_without_border"></td>
            <td class="card_cell_number_middle_without_border"></td>
            <td class="card_cell_number_right_without_border"></td>
          </tr>
          <tr>
            <td class="card_cell_number_left_without_border"></td>
            <td class="card_cell_number_middle_without_border"></td>
            <td class="card_cell_number_middle_without_border"></td>
            <td class="card_cell_number_middle_without_border"></td>
            <td class="card_cell_number_right_without_border"></td>
          </tr>
          <tr>
            <td *ngIf="!this.canAccessLinkMenu()" class="card_cell_direction card_cell_direction_redux_left" role="button"></td>
            <td *ngIf="this.canAccessLinkMenu()" class="card_cell_direction pointer card_cell_direction_redux_left" role="button" id="sideMenuButton"
                (click)="openSideMenu('left')"
                [routerLink]="[{ outlets: { sideMenu: ['side-menu']}}]"
                emRecommendationIndicator [cells]="cardPattern.cardCells" [cardDeckId]="cardPattern.cardDeckId"
                [deckType]="cardPattern.cardDeckType" [patternId]="cardPattern.id"></td>
            <td class="card_cell_number_middle_without_border"></td>
            <td class="card_cell_number_middle_without_border"></td>
            <td class="card_cell_number_middle_without_border"></td>
            <td *ngIf="!this.canAccessLinkMenu()" class="card_cell_direction card_cell_direction_redux_right" role="button"></td>
            <td *ngIf="this.canAccessLinkMenu()" class="card_cell_direction pointer card_cell_direction_redux_right" role="button"
                (click)="openSideMenu('right')"
                [routerLink]="[{ outlets: { sideMenu: ['side-menu']}}]"
                emRecommendationIndicator [cells]="cardPattern.cardCells" [cardDeckId]="cardPattern.cardDeckId"
                [deckType]="cardPattern.cardDeckType" [patternId]="cardPattern.id"></td>
          </tr>
          <tr>
            <td class="card_cell_number_left_without_border_lastrow"></td>
            <td class="card_cell_number_middle_without_border"></td>
            <td *ngIf="!this.canAccessLinkMenu()" class="card_cell_direction card_cell_direction_redux_down" role="button"></td>
            <td *ngIf="this.canAccessLinkMenu()" class="card_cell_direction pointer card_cell_direction_redux_down" role="button"
                (click)="openSideMenu('bottom')"
                [routerLink]="[{ outlets: { sideMenu: ['side-menu']}}]"
                emRecommendationIndicator [cells]="cardPattern.cardCells" [cardDeckId]="cardPattern.cardDeckId"
                [deckType]="cardPattern.cardDeckType" [patternId]="cardPattern.id"></td>
            <td class="card_cell_number_middle_without_border"></td>
            <td class="card_cell_number_right_without_border"></td>
          </tr>
          </tbody>
        </table>
        <div class="card_frontside_text card_frontside_text_fix">
          <div class="category_attribution_text_center disable-text-selection" emAddedGameElement [elementId]="cardPattern.id">
            {{ cardPattern.summary }}
          </div>
        </div>
      </div>
    </mat-card>
  </mat-sidenav-content>
</mat-sidenav-container>
<ng-template #loading>
  <div style="color:#999999">Karte wird geladen...</div>
</ng-template>

